export function MatcoraBrandMark({
  className = '',
  alt = 'Matcora',
}: {
  className?: string;
  alt?: string;
}) {
  return (
    <img
      src="/matcora-logo-oauth-120x120-larger-rounded.png"
      alt={alt}
      className={`block object-contain ${className}`}
    />
  );
}
